// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dvmk3O9k","shouldUseBorderOnFallback":"yE503Du0"};